<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="活动名称">
          <el-input v-model="searchForm.activityName" placeholder="请输入活动名称" clearable/>
        </el-form-item>
        <el-form-item label="配置日期">
          <date-range-picker :value="configTime" @change="value => configTime = value" @getChange="dateChange"/>
        </el-form-item>
        <el-form-item label="邮件状态">
          <el-select v-model="searchForm.state" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="关闭" :value="1"></el-option>
            <el-option label="开启" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据导出类型">
          <el-select v-model="searchForm.exportType" placeholder="请选择导出类型" clearable>
            <el-option v-for="item in exportTypeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动编号">
          <el-input v-model="searchForm.activityId" placeholder="请输入活动名称" clearable/>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <el-button type="default" :loading="exportLoading" @click="handleExport">导出</el-button>
      </el-form>
    </module-card>

    <module-card title="数据导出自动化管理">
      <el-button type="primary" icon="el-icon-plus" @click="addAutomation">新增</el-button>
      <el-table class="table" border :data="list" v-loading="tableLoading">
        <el-table-column
          label="配置日期"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="数据导出类型"
          prop="exportType">
          <template slot-scope="scope">
            {{ scope.row.exportType === 1 ? '商户已绑卡名单导出邮件' : '' }}
          </template>
        </el-table-column>
        <el-table-column
          label="活动银行"
          prop="bankName">
        </el-table-column>
        <el-table-column
          label="活动编号"
          prop="activityId">
        </el-table-column>
        <el-table-column
          label="活动名称"
          prop="activityName">
        </el-table-column>
        <el-table-column
          label="邮件收件人"
          prop="addressee">
        </el-table-column>
        <el-table-column
          label="邮件抄送"
          prop="ccAddressee">
        </el-table-column>
        <el-table-column
          label="操作人"
          prop="operator">
        </el-table-column>
        <el-table-column
          label="邮件名称"
          prop="mailName">
        </el-table-column>
        <el-table-column
          label="邮件状态"
          prop="state">
          <template slot-scope="scope">
            {{ scope.row.state === 0 ? '正常' : '关闭' }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="130px">
          <template slot-scope="scope">
            <div class="flex-space-around">
              <el-button type="text" style="padding: 0px" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" style="padding: 0px" @click="handleChangeState(scope.row)">{{ scope.row.state === 0 ? '关闭' : '开启' }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="pageNo" :size="pageSize"
                  @changePage="value => { this.pageNo = value; getList() }"/>
    </module-card>
    <dialog-info :visible.sync="showAddDialog" :title="state ? '新增数据导出邮件' : '修改数据导出邮件'" :showCancelBtn="false" :showConfirmBtn="false" @close="dataForm = $options.data().dataForm">
      <el-form ref="dataForm" :model="dataForm" :rules="ruleData" label-width="110px" label-position="left" :disabled="isCheckDetail">
        <el-form-item prop="exportType" label="数据导出类型">
          <el-select v-model="dataForm.exportType" placeholder="请选择">
            <el-option
              v-for="item in exportTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="mailName" label="邮件名称">
          <el-input v-model="dataForm.mailName" placeholder="请输入邮件名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="activityId" label="活动编号">
          <el-input v-model="dataForm.activityId" placeholder="请输入活动编号" clearable></el-input>
        </el-form-item>
        <el-form-item prop="addressee" label="收件人">
          <el-input type="textarea" v-model.trim="dataForm.addressee" placeholder="输入邮件地址，多个邮件地址用英文，隔开" :rows="3"></el-input>
        </el-form-item>
        <el-form-item prop="ccAddressee" label="抄送">
          <el-input type="textarea" v-model.trim="dataForm.ccAddressee" placeholder="输入邮件地址，多个邮件地址用英文，隔开" :rows="3"></el-input>
        </el-form-item>
        <el-form-item prop="sendTime" label="邮件发送时间">
          <el-select v-model="dataForm.sendTime" placeholder="请选择" clearable>
            <el-option
              v-for="item in sendTimeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cardBins" label="邮件模板下载">
          <a href="static/商户已绑卡名单导出邮件.csv" class="downloadLink">点击下载</a>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm" v-show="state">重置</el-button>
          <el-button type="primary" @click="submitAdd">{{ this.state ? '确认新增' : '确认修改' }}</el-button>
        </el-form-item>
      </el-form>
    </dialog-info>
  </div>
</template>
<script>
import dialogInfo from '@/components/layout/dialogInfo'
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import { downJumpConfirm } from '@/assets/js/utils'

export default {
  name: 'automationExport',
  components: {
    pagination,
    dateRangePicker,
    dialogInfo
  },
  data () {
    return {
      id: '',
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tableLoading: false,
      searchForm: {
        creatTimeStart: '',
        creatTimeEnd: '',
        activityId: '',
        activityName: '',
        exportType: '',
        state: ''
      },
      dataForm: {
        activityId: '',
        exportType: '',
        mailName: '',
        addressee: '',
        ccAddressee: '',
        sendTime: ''
      },
      exportLoading: false,
      searchLoading: false,
      configTime: [],
      showAddDialog: false,
      state: true, // true 新增; false 修改
      exportTypeList: [{
        value: 1,
        label: '商户已绑卡名单导出邮件'
      }],
      sendTimeList: [
        { value: '5', label: '05:00' },
        { value: '6', label: '06:00' },
        { value: '7', label: '07:00' },
        { value: '8', label: '08:00' },
        { value: '9', label: '09:00' },
        { value: '10', label: '10:00' },
        { value: '11', label: '11:00' },
        { value: '12', label: '12:00' },
        { value: '13', label: '13:00' },
        { value: '14', label: '14:00' },
        { value: '15', label: '15:00' },
        { value: '16', label: '16:00' }
      ],
      ruleData: {
        activityId: [{
          required: true,
          message: '请输入活动编号',
          trigger: 'blur'
        }],
        exportType: [{
          required: true,
          message: '请选择导出类型',
          trigger: 'change'
        }],
        mailName: [{
          required: true,
          message: '请输入邮件名称',
          trigger: 'blur'
        }],
        addressee: [{
          required: true,
          message: '请输入邮件地址',
          trigger: 'blur'
        }],
        sendTime: [{
          required: true,
          message: '请输入发送时间',
          trigger: 'change'
        }]
      }

    }
  },
  mounted () {
    this.init()
  },
  computed: {},
  methods: {
    async init () {
      this.getList()
    },
    dateChange (value) {
      this.configTime = value
    },
    getList () {
      this.searchForm.creatTimeStart = this.configTime && this.configTime[0] ? this.configTime[0] : ''
      this.searchForm.creatTimeEnd = this.configTime && this.configTime[1] ? this.configTime[1] : ''
      this.tableLoading = true
      this.searchLoading = true
      const params = Object.assign({}, this.searchForm, {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      this.$axios.post(this.$api.exportAutomationList, params).then(res => {
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
        this.tableLoading = false
        this.searchLoading = false
      })
    },
    handleEdit (row) {
      this.state = false
      this.showAddDialog = true
      this.dataForm.activityId = row.activityId || ''
      this.dataForm.exportType = row.exportType || ''
      this.dataForm.mailName = row.mailName || ''
      this.dataForm.addressee = row.addressee || ''
      this.dataForm.ccAddressee = row.ccAddressee || ''
      this.dataForm.sendTime = row.sendTime || ''
      this.dataForm.id = row.id || ''
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    handleExport () {
      this.searchForm.creatTimeStart = this.configTime && this.configTime[0] ? this.configTime[0] : ''
      this.searchForm.creatTimeEnd = this.configTime && this.configTime[1] ? this.configTime[1] : ''
      this.exportLoading = true
      this.$axios.post(this.$api.exportAutomation, this.searchForm).then((res) => {
        console.log(res)
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    handleChangeState (row) {
      this.$confirm('是否' + (row.state === 0 ? '关闭' : '开启') + '邮件自动导出?', '温馨提示').then(res => {
        const params = {
          state: row.state === 0 ? 1 : 0,
          id: row.id
        }
        this.$axios.post(this.$api.exportAutomationState, params).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              showClose: 'true',
              message: (row.state === 0 ? '关闭' : '开启') + '成功'
            })
            this.getList()
          }
        })
      }).catch(() => {})
    },
    search () {
      this.pageNo = 1
      this.getList()
    },
    submitAdd () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let api
          let message
          if (this.state) {
            api = 'addExportAutomation'
            message = '新增成功'
          } else {
            api = 'editExportAutomation'
            message = '修改成功'
          }
          this.$axios.post(this.$api[api], this.dataForm).then(res => {
            if (res.respCode === '0') {
              this.$message({
                type: 'success',
                showClose: 'true',
                message: message
              })
              this.showAddDialog = false
              this.getList()
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    addAutomation () {
      this.state = true
      this.showAddDialog = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    resetForm () {
      this.dataForm = this.$options.data().dataForm
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    }
  }
}
</script>
<style scoped>
  .table {
    margin-top: 20px;
  }
  .form-flex-item {
    margin-right: 5px;
  }
  .icon {
    width: 14px;
    height: 14px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: #409EFF;
    color: #fff;
    margin-left: 12px;
    cursor: pointer;
    user-select: none; /* Standard syntax */
  }
  .form-input {
    width: 550px;
  }
  .inner-input {
    width: 240px;
  }
  .footer {
    text-align: center;
  }
</style>
